import { render } from "./BaseDropdown.vue?vue&type=template&id=00ed0b30"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script